<div class="page-title">
  Histórico<span *ngIf="actionName"> — {{ actionName }}</span>
</div>

<app-table
  [lazy]="true"
  [cols]="cols"
  [findPage]="findPage"
  [service]="marketingService"
  [fixedFilters]="fixedFilters"
  [addButton]="false"
  [dropdownFilters]="dropdownFilters"
  sortField="createdAt"
  [sortOrder]="-1"
  tableTitle="Créditos da ação"
  modelName="créditos"
/>
